import mapKeys from 'lodash/mapKeys';

export default function copyPrefixedObjectKeys<T extends {}>(object: T, prefix: string) {
  return {
    ...object,
    ...mapKeys<T>(object, (value, key) => prefix + key),
  };
}
